<template>
  <el-table ref="sysTable"
          :data="tableList"
          :row-key="rowKey"
          :height="tableHeight"
          default-expand-all
          highlight-current-row
          :header-cell-style="getHeaderCellStyle"
          :cell-style="getCellStyle">
    <!--序号-->
    <el-table-column type="index" width="55" label="序号" align="center" v-if="showIndex"></el-table-column>
    <!--数据-->
    <sys-table-column v-for="(colum, index) in columList" :key="index" :tableColum="colum"
                      @handlerElSwitch="handlerElSwitch"
                      @openUrlCode="openUrlCode"></sys-table-column>
    <!--操作-->
    <el-table-column label="操作" align="center" :width="operationWidth" v-if="showOperation">
      <template slot-scope="scope">
        <slot name="slotButton" :rowData="scope.row" class="slotButton"/>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import SysTableColumn from "@/components/system/SysTableColumn";
export default {
  components: {
    SysTableColumn
  },
  data(){
    return{};
  },
  props: {
    //操作栏宽度
    operationWidth:{
      type:String,
      default:"300px"
    },
    //是否显示序号
    showIndex:{
      type:Boolean,
      default:true
    },
    //table数据
    tableList:{
        type:Array,
        default: function() {
            return []
        }
    },
    //table主键
    rowKey:{
      type: String,
      default: "id",
    },
    //列表字段
    columList:{
        type:Array,
        default: function() {
            return []
        }
    },
    //列表高度
    tableHeight:{
      type:String,
      default: null,
    },
    //是否展示操作栏
    showOperation:{
      type:Boolean,
      default:true
    }
  },
  methods: {
    getCellStyle:function({row, column, rowIndex, columnIndex}){
        if(rowIndex%2 === 1){
            return "height: 50px;background: #f8fcff;opacity: 1;padding: 0;"
        }else{
          return "height: 50px;background: #fff;opacity: 1;padding: 0;"
        }
    },
    getHeaderCellStyle:function({row, column, rowIndex, columnIndex}){
        if(row.length-1 === columnIndex){
            return "height:60px;opacity: 1;background: #8fcbff;color: #333333;border-radius: 0px 4px 0px 0px;"
        }
        if(columnIndex === 0){
            return "height:60px;opacity: 1;background: #8fcbff;color: #333333;border-radius: 4px 0px 0px 0px;"
        }
        return "height:60px;background: #8fcbff;color: #333333;opacity: 1;"
    },
    handlerElSwitch:function (row) {
      this.$emit('handlerElSwitch',row);
    },
    openUrlCode:function (row) {
      this.$emit('openUrlCode',row);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
